import "./LabTestAndPanelViewComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {ITableColumn} from "../../../../../shared/models/table.model";
import SwitchComponent from "../../../../../shared/components/core/switch/switchComponent";
import {CommonService} from "../../../../../shared/services";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import _ from "lodash";
import TableV2Component from "../../../../../shared/components/table-components/table-v2/TableV2Component";
import TooltipComponent from "../../../../../shared/components/tooltip/tooltipComponent";

interface LabTestAndPanelViewComponentProps {
    labTestAndPanel: any;
    canEdit: boolean;
    onEditModeOpen: Function
}

const LabTestAndPanelViewComponent = (props: LabTestAndPanelViewComponentProps) => {
    const {labTestAndPanel, canEdit, onEditModeOpen} = props;

    const [testAndPanel, setTestAndPanel] = useState<any>(undefined);

    useEffect(() => {
        if (labTestAndPanel) {
            setTestAndPanel(labTestAndPanel);
        }
    }, [labTestAndPanel]);

    const onToggleTest = useCallback((item: any) => {
        CommonService._lab.toggleLabTest(item.id, {})
            .then((response: IAPIResponseType<any>) => {
                setTestAndPanel((prevState: any) => {
                    return {
                        ...prevState,
                        testDetails: prevState?.testDetails?.map((panel: any) => {
                            if (panel.id === item.id) {
                                return {
                                    ...panel,
                                    isActive: !panel.isActive
                                }
                            }
                            return panel;
                        })
                    }
                })
                CommonService._alert.showToast(response?.message || `Test has been  ${item?.isActive ? "deactivated" : "activated"}`, "success");
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || `Error while ${item?.isActive ? "deactivating" : "activating"} the Test`, "error");
            });
    }, []);

    const onTogglePanel = useCallback((item: any) => {
        CommonService._lab.toggleLabPanel(item.id, {})
            .then((response: IAPIResponseType<any>) => {
                setTestAndPanel((prevState: any) => {
                    const updatedPanel = _.cloneDeep(prevState?.panelDetails?.map((panel: any) => {
                            if (panel.id === item.id) {
                                return {
                                    ...panel,
                                    isActive: !panel.isActive
                                }
                            }
                            return panel;
                        }
                    ))
                    return {
                        ...prevState,
                        panelDetails: updatedPanel
                    }
                })
                CommonService._alert.showToast(response?.message || `Test Panel has been  ${item?.isActive ? "deactivated" : "activated"}`, "success");
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || `Error while ${item?.isActive ? "deactivating" : "activating"} the Test Panel`, "error");
            });
    }, []);

    const [testColumns] = useState<ITableColumn[]>([
        {
            id: 'name',
            label: 'Test Name',
            isDefaultColumn: true,
            width: "1000",
            content: (item: any) => (
                item?.testDetail ?
                    <>
                        {item?.testDetail?.name}
                    </> : <>-</>
            )
        },
        {
            id: 'isActive',
            label: 'Active/Inactive',
            isDefaultColumn: true,
            fixed: "right",
            align: "center",
            width: "200",
            content: (item: any, index: any) => (
                <React.Fragment>
                    {
                        !item?.testDetail?.isActive ?
                            <TooltipComponent tooltip={"Test is inactive"}>
                                <SwitchComponent
                                    disabled={!item?.testDetail?.isActive}
                                    size={"small"}
                                    checked={item.isActive}
                                    onUpdate={() => onToggleTest(item)}/>
                            </TooltipComponent> :
                            <SwitchComponent
                                disabled={!item?.testDetail?.isActive}
                                size={"small"}
                                checked={item.isActive}
                                onUpdate={() => onToggleTest(item)}/>
                    }

                </React.Fragment>
            )
        },
    ]);

    const [panelColumns] = useState<ITableColumn[]>([
        {
            id: 'name',
            label: 'Panel Name',
            isDefaultColumn: true,

            content: (item: any) => (
                item?.panelDetail ?
                    <>
                        {item?.panelDetail?.name}
                    </> : <>-</>
            )
        },
        {
            id: 'isActive',
            label: 'Active/Inactive',
            isDefaultColumn: true,
            fixed: "right",
            align: "center",
            width: "200",
            content: (item: any, index: any) => (
                <React.Fragment>
                    <SwitchComponent
                        disabled={!item?.panelDetail?.isActive}
                        size={"small"}
                        checked={item.isActive}
                        onUpdate={() => onTogglePanel(item)}/>
                </React.Fragment>
            )
        },
    ]);

    return (
        <div className={'lab-test-and-panel-view-component details-tab-data-content'}>
            <div className="details-tab-data-header">
                <div className="view-and-edit-title"></div>
                {canEdit &&
                    <div>
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={() => {
                                onEditModeOpen(testAndPanel)
                            }}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                }
            </div>
            <div className="details-tab-data-body">
                {
                    testAndPanel?.testDetails?.length > 0 &&
                    <div className={'t-table-container'}>
                        <TableV2Component
                            columns={testColumns}
                            data={testAndPanel?.testDetails}
                        />
                    </div>
                }
                {
                    testAndPanel?.panelDetails?.length > 0 &&
                    <div className={'t-table-container'}>
                        <TableV2Component columns={panelColumns} data={testAndPanel?.panelDetails}/>
                    </div>
                }
            </div>
        </div>
    );

}
export default LabTestAndPanelViewComponent;